import { ColorRepresentation, OrthographicCamera, PerspectiveCamera } from 'three';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';

/**
 * 子视图接口
 */
export interface ISubView {
  name: string;
  /** 绝对渲染尺寸：left / bottom / width / height */
  viewport: [number, number, number, number];
  camera: OrthographicCamera | PerspectiveCamera;
  backgroundColor?: ColorRepresentation;
  zoom: number;
  composer?: EffectComposer | null;
}

export class SubViews {
  public views: ISubView[];
  public isShow: boolean;
  public layer: number;

  constructor(views: ISubView[], isShow: boolean, layer: number = 0) {
    this.views = views;
    this.isShow = isShow;
    this.layer = layer;
  }

  static updateViewViewport(view: ISubView, viewport: ISubView['viewport']) {
    view.viewport = viewport;
    view.composer && view.composer.setSize(viewport[2], viewport[3]);
  }

  updateCameraSize(width: number, height: number) {}
}
